import React, { useState, useEffect } from "react";
import Layout from "components/structure/Layout";
import ImportList from "../Common/ImportList";

const ImportContract = () => {
  return (
    <Layout title={"Import Contract"}>
      <ImportList entityName="ImportContract" displayName="Import Contract" />
    </Layout>
  );
};

export default ImportContract;
